import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import StepListOfServices from './step-list-of-services';
import StepPersonnalInfosForm from './step-personnal-infos-form';
import StepPayment from './step-payment';
import PaidStepServices from './paid-step';
import ErrorStepServices from './error-step';
import StepUploadFiles from './step-upload-files';

import * as _ from 'lodash';
import { useSubdomain } from '../../contexts/subdomain';

export default function ServicePage() {
    const { subdomain, userId, subdomainData } = useSubdomain();
    const [step, setStep] = useState("step1");

    const [formData, setFormData] = useState({
        customer: {},
        billing: {},
        services: [],
        language: 'fr',
        society: '',
        subdomain: '',
        subdomainId: '',
        subdomainData: null,
        userId: '',
        type: "services"
    });

    useEffect(() => {
        if (!subdomainData) return;

        const apiUser = subdomainData?.apiUser || {};
        const apiBilling = subdomainData?.apiBilling?.address || subdomainData?.apiBilling || {};

        setFormData((prevData) => ({
            ...prevData,

            society: subdomainData?.fullName || prevData.society || '',
            subdomainId: subdomainData?._id || prevData.subdomainId || '',
            subdomainData: subdomainData || prevData.subdomainData || null,

            customer: {
                ...prevData.customer,
                userId: userId || apiUser.userId || apiUser.uniqid || prevData.customer.userId || '',
                firstname: apiUser.firstname || prevData.customer.firstname || '',
                lastname: apiUser.lastname || prevData.customer.lastname || '',
                email: apiUser.email || prevData.customer.email || '',
                phone: apiUser.phone || prevData.customer.phone || '',
            },

            billing: {
                ...prevData.billing,

                address: apiBilling.address || prevData.billing.address || '',
                address2: apiBilling.address2 || prevData.billing.address2 || '',
                address3: apiBilling.address3 || prevData.billing.address3 || '',
                city: apiBilling.city || prevData.billing.city || '',

                // Important fix here
                postalCode:
                    apiBilling.postalCode ||
                    apiBilling.postalcode ||
                    prevData.billing.postalCode ||
                    '',

                country: apiBilling.country || prevData.billing.country || '',

                // Field mapping
                companyName:
                    apiBilling.companyName ||
                    apiBilling.company ||
                    prevData.billing.companyName ||
                    '',

                VATNumber:
                    apiBilling.VATNumber ||
                    apiBilling.tax ||
                    prevData.billing.VATNumber ||
                    '',
            },
        }));
    }, [subdomainData, userId]);

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            subdomain: subdomain || '',
            subdomainId: subdomainData?._id || prevData.subdomainId || '',
            subdomainData: subdomainData || prevData.subdomainData || null,
            userId: userId || '',
            customer: {
                ...prevData.customer,
                userId: userId || prevData.customer.userId || ''
            }
        }));
    }, [subdomain, userId, subdomainData]);

    const handleReturnedData = (data) => {
        setFormData((prevData) => ({
            ...prevData,
            ...data,
        }));

        setStep(data.step);
    };

    return (
        <div className='bg-backgroundColor'>
            <Helmet>
                <title>FISKA\Group expert dans la gestion d'entreprise</title>
                <meta
                    name="description"
                    content="Nous accompagnons les VDI, indépendants, micro-entreprises et TPE/PME depuis plus de 20 ans dans la création et la gestion d’entreprise."
                />
            </Helmet>

            <div className='m-auto max-w-5xl py-6 md:pt-14 mt-16 md:mt-20'>
                {step === "step1" && (
                    <StepListOfServices
                        previouslySelectedServices={_.get(formData, 'services', []).map(service => service._id)}
                        returnedData={handleReturnedData}
                    />
                )}

                {step === "step2" && (
                    <StepPersonnalInfosForm
                        returnedData={handleReturnedData}
                        initialFormData={formData}
                    />
                )}

                {step === "step3" && (
                    <StepUploadFiles
                        selectedServices={_.get(formData, 'services', [])}
                        initialFormData={formData}
                        returnedData={handleReturnedData}
                    />
                )}

                {step === "step4" && (
                    <StepPayment
                        formData={formData}
                        returnedData={handleReturnedData}
                    />
                )}

                {step === "paid" && (
                    <PaidStepServices />
                )}

                {step === "error" && (
                    <ErrorStepServices />
                )}
            </div>
        </div>
    );
}